export function isValidEmailRegex(value) {
  //console.log("Inside isValidEmailRegex() - value:", value);
  if (!value) return false
  const regex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return regex.test(value)
}

export function emailWebsiteGet(email) {
  // Return what comes after '@' in the email, assuming there is a @
  return email ? email.split('@').pop() : ''
}
export function getDomainFromEmail(email) {
  // Return null in case of no e-mail
  if (!email) {
    return ''
  }
  // Detect the current domain from the e-mail
  const domainParser = require('tld-extract')
  const emailWebsite = emailWebsiteGet(email)
  const urlEmailWebsite = 'http://' + emailWebsite // create a fake URL for the parsing
  try {
    return domainParser(urlEmailWebsite).domain
  } catch (err) {
    console.warn('Invalid TLD or domain in email:', email, err)
    // Fallback: return the raw domain
    return ''
  }
}

export function isEmailFromPopularProvider(email) {
  const domain = getDomainFromEmail(email)
  const popularProviderList = [
    /* Default domains included */
    'aol.com',
    'att.net',
    'comcast.net',
    'facebook.com',
    'gmail.com',
    'gmx.com',
    'googlemail.com',
    'google.com',
    'hotmail.com',
    'hotmail.co.uk',
    'mac.com',
    'me.com',
    'mail.com',
    'msn.com',
    'live.com',
    'sbcglobal.net',
    'verizon.net',
    'yahoo.com',
    'yahoo.co.uk',

    /* Other global domains */
    'email.com',
    'fastmail.fm',
    'games.com' /* AOL */,
    'gmx.net',
    'hush.com',
    'hushmail.com',
    'icloud.com',
    'iname.com',
    'inbox.com',
    'lavabit.com',
    'love.com' /* AOL */,
    'outlook.com',
    'pobox.com',
    'protonmail.ch',
    'protonmail.com',
    'tutanota.de',
    'tutanota.com',
    'tutamail.com',
    'tuta.io',
    'keemail.me',
    'rocketmail.com' /* Yahoo */,
    'safe-mail.net',
    'wow.com' /* AOL */,
    'ygm.com' /* AOL */,
    'ymail.com' /* Yahoo */,
    'zoho.com',
    'yandex.com',

    /* United States ISP domains */
    'bellsouth.net',
    'charter.net',
    'cox.net',
    'earthlink.net',
    'juno.com',

    /* British ISP domains */
    'btinternet.com',
    'virginmedia.com',
    'blueyonder.co.uk',
    'freeserve.co.uk',
    'live.co.uk',
    'ntlworld.com',
    'o2.co.uk',
    'orange.net',
    'sky.com',
    'talktalk.co.uk',
    'tiscali.co.uk',
    'virgin.net',
    'wanadoo.co.uk',
    'bt.com',

    /* Domains used in Asia */
    'sina.com',
    'sina.cn',
    'qq.com',
    'naver.com',
    'hanmail.net',
    'daum.net',
    'nate.com',
    'yahoo.co.jp',
    'yahoo.co.kr',
    'yahoo.co.id',
    'yahoo.co.in',
    'yahoo.com.sg',
    'yahoo.com.ph',
    '163.com',
    'yeah.net',
    '126.com',
    '21cn.com',
    'aliyun.com',
    'foxmail.com',

    /* French ISP domains */
    'hotmail.fr',
    'live.fr',
    'laposte.net',
    'yahoo.fr',
    'wanadoo.fr',
    'orange.fr',
    'gmx.fr',
    'sfr.fr',
    'neuf.fr',
    'free.fr',

    /* German ISP domains */
    'gmx.de',
    'hotmail.de',
    'live.de',
    'online.de',
    't-online.de' /* T-Mobile */,
    'web.de',
    'yahoo.de',

    /* Italian ISP domains */
    'libero.it',
    'virgilio.it',
    'hotmail.it',
    'aol.it',
    'tiscali.it',
    'alice.it',
    'live.it',
    'yahoo.it',
    'email.it',
    'tin.it',
    'poste.it',
    'teletu.it',

    /* Russian ISP domains */
    'mail.ru',
    'rambler.ru',
    'yandex.ru',
    'ya.ru',
    'list.ru',

    /* Belgian ISP domains */
    'hotmail.be',
    'live.be',
    'skynet.be',
    'voo.be',
    'tvcablenet.be',
    'telenet.be',

    /* Argentinian ISP domains */
    'hotmail.com.ar',
    'live.com.ar',
    'yahoo.com.ar',
    'fibertel.com.ar',
    'speedy.com.ar',
    'arnet.com.ar',

    /* Domains used in Mexico */
    'yahoo.com.mx',
    'live.com.mx',
    'hotmail.es',
    'hotmail.com.mx',
    'prodigy.net.mx',

    /* Domains used in Canada */
    'yahoo.ca',
    'hotmail.ca',
    'bell.net',
    'shaw.ca',
    'sympatico.ca',
    'rogers.com',

    /* Domains used in Brazil */
    'yahoo.com.br',
    'hotmail.com.br',
    'outlook.com.br',
    'uol.com.br',
    'bol.com.br',
    'terra.com.br',
    'ig.com.br',
    'itelefonica.com.br',
    'r7.com',
    'zipmail.com.br',
    'globo.com',
    'globomail.com',
    'oi.com.br',

    /* Israeli ISP / personal email domains — mirrors popularEmailProviders in
       tprm libs/go/lib-api-common/util/tid_util.go; keep in sync with backend.
       This list is also duplicated in vendictnew logicJs/popularEmailDomains.js
       and vendictnew functions/user_before_create/index.js — any edit here must
       be applied to all copies */
    '012.net',
    '012.net.il',
    '013.net',
    '013.net.il',
    '013net.net',
    '013net.net.il',
    '013netvision.co.il',
    '014.net.il',
    '015.net',
    '015.net.il',
    '017.net.il',
    '018.net.il',
    'bezeqint.net',
    'bezeqint.net.il',
    'actcom.co.il',
    'barak-online.net',
    'barak-online.net.il',
    'barak.net.il',
    'hotnet.co.il',
    'inter.net.il',
    'netvision.co.il',
    'netvision.net',
    'netvision.net.il',
    'rimon.net',
    'rimon.net.il',
    'smile.net.il',
    'walla.co.il',
    'walla.com',
    'zahav.net.il',
    /* Not in the tprm Go map (flagged to backend) — from Michael's list */
    'walla.net.il',
    'isdn.net.il',
    'orange.net.il',
  ]
  return popularProviderList.includes(domain) > 0
}

/**
 * Check if an email is allowed based on whitelist/blacklist settings
 * @param {string} email - The email to check
 * @param {Object} settings - The settings object with mode, whitelistEmails, blacklistEmails
 * @returns {boolean} - True if allowed, false if blocked
 */
export function isEmailAllowedBySettings(email, settings) {
  // console.log('Inside isEmailAllowedBySettings(email, settings) - email, _.isEmpty(email), settings:', email, _.isEmpty(email), settings)
  // If no settings, allow by default
  if (!settings || _.isEmpty(email)) return false

  const mode = settings.mode || 'denyAllExceptWhitelist'
  const whitelistEmails = Array.isArray(settings.whitelistEmails)
    ? settings.whitelistEmails.map((e) => e.toLowerCase())
    : []
  const blacklistEmails = Array.isArray(settings.blacklistEmails)
    ? settings.blacklistEmails.map((e) => e.toLowerCase())
    : []

  const userEmail = email.toLowerCase()
  const userDomain = emailWebsiteGet(userEmail)

  /**
   * Check if email or domain matches any entry in the list
   * Entries can be full emails (user@domain.com) or domains (domain.com)
   */
  const matchesList = (list) => {
    return list.some((entry) => {
      // Check if entry is a full email match
      if (entry.includes('@')) {
        return userEmail === entry
      }
      // Check if entry is a domain match (entry matches user's domain or subdomain)
      return userDomain === entry || userDomain.endsWith('.' + entry)
    })
  }

  if (mode === 'denyAllExceptWhitelist') {
    // Deny all except those in whitelist
    return matchesList(whitelistEmails)
  } else {
    // allowAllExceptBlacklist - Allow all except those in blacklist
    return !matchesList(blacklistEmails)
  }
}

export function teamIdGet(user) {
  console.log(
    'Inside teamIdGet(user) - email, emailVerified:',
    user,
    user.email,
    user.emailVerified
  )
  // Given user email, return the team ID, i.e. the Google R2 syntax for
  // this domain
  // In practice, "vendict.com" should become ".*@vendict[.]com" if the email
  // is verified
  // In case of popular domain (e.g., withindata@gmail.com) or unverified email,
  // then put the full email in the rule instead to avoid confederation
  const email = user.email
  if (!email) return null
  const emailWebsite = emailWebsiteGet(email)
  // replace all the dots with '[.]'
  const websiteModified = emailWebsite.replace(/\./g, '[.]')
  let teamIdStr = '.*@' + websiteModified
  // disabled emailVerified check since on user creation emails are expected to be non-verified
  const noTeam = isEmailFromPopularProvider(email) // || user.emailVerified === false
  // replace all the dots with '[.]' for the email only
  if (noTeam) teamIdStr = email.replace(/\./g, '[.]')
  console.log(
    'Inside teamIdGet - emailWebsite, websiteModified, teamIdStr, noTeam:',
    emailWebsite,
    websiteModified,
    teamIdStr,
    noTeam
  )
  return teamIdStr
}
